<template>
  <a-modal
    :maskClosable="false"
    :confirmLoading="confirmLoading"
    :visible="visible"
    title="数据编辑"
    @ok="submitForm"
    @cancel="handleCancel"
  >
    <a-form
      :form="form"
      :layout="formLayout"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-item :label="currentYear">
        <a-input
          v-decorator="[
            'value1',
            {
              initialValue: tableRow.value1,
            },
          ]"
        />
      </a-form-item>
      <a-form-item :label="prevYear">
        <a-input
          v-decorator="[
            'value2',
            {
              initialValue: tableRow.value2,
            },
          ]"
        />
      </a-form-item>
      <a-form-item :label="beforePrevYear">
        <a-input
          v-decorator="[
            'value3',
            {
              initialValue: tableRow.value3,
            },
          ]"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
import { analyseEdit } from '../api'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      formLayout: 'horizontal',
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 17 },
      },
      selectList: [],
      treeData: [],
      replaceFields: {
        children: 'children',
        title: 'name',
        key: 'id',
      },
      username: {
        value: 'benjycui',
      },
      tableRow: {
        value1: '',
        value2: '',
        value3: '',
      },
      currentYear: '',
      prevYear: '',
      beforePrevYear: '',
      rowKey: '',
    }
  },
  computed: {
    ...mapGetters('app', ['company']),
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: 'createForm' })
  },
  mounted() {},
  methods: {
    // 新增
    add(row, formYear) {
      this.rowKey = row.key
      this.currentYear = formYear
      this.prevYear = Number(formYear) - 1
      this.beforePrevYear = Number(formYear) - 2

      this.visible = true
      this.form.resetFields()
      this.tableRow = {}
      this.checkedKeys = []
      this.id = ''
    },
    // 取消
    handleCancel() {
      this.visible = false
      this.form.resetFields()
    },
    // 提交数据
    submitForm(e) {
      e.preventDefault()
      this.form.validateFields(async (err, values) => {
        if (!err) {
          let data = Object.assign({}, values)
          let submitData = {}
          let editData = []
          let year = this.currentYear
          for (let i = 0; i < 3; i++) {
            editData.push({
              key: this.rowKey,
              year: year - i,
              value: data[`value${i + 1}`],
            })
          }
          submitData.customerCode = this.company.code
          submitData.items = editData
          //this.$emit('create', data)
          try {
            await analyseEdit(submitData)
            this.handleCancel()
            this.$emit('getTableData')
          } catch (err) {
            console.log(err)
          }
        }
      })
    },
  },
}
</script>
